module.exports = __webpack_public_path__ + "img/empresa.0ff552d7.png";